document.addEventListener("scroll", () => {
	document.getElementById("header").classList.toggle("scrolled", window.scrollY > 0);
});

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll("a").forEach(anchor => {
		try {
			let url = new URL(anchor.href);
		
			if (url.hostname !== 'learn.arly.com' && url.hostname !== 'arly.com' && url.hostname !== window.location.hostname) {
				anchor.target = "_blank";
			}
		}
		catch (error) {}
	});
});

document.getElementById('blog-tag-select')?.addEventListener('change', (event) => {window.location = event.target.value;});


document.querySelectorAll('.grid-slider').forEach(slider => {
    let sliderID = slider.dataset.slider;
    let navEl = `#nav-container-${sliderID}`;
    tns({
        container: slider,
        items: 1,
        slideBy: 'page',
        autoplay: false,
        // disable: true,
        responsive: {
          768: {
            disable: true,
          }
        }
    });
});


document.querySelectorAll('.package-expand-collapse ').forEach(expandCollapse => {
    expandCollapse.addEventListener('click', () => {
        expandCollapse.closest('.package-card').classList.toggle('expanded');
    });
});


document.querySelectorAll('.btn-package-inquiry').forEach(button => {
    button.addEventListener('click', () => {
        let package = button.dataset.package;
        let form = document.getElementById('demo-form-div');
        form.querySelector('input[name="package_interest"]').value = package;
    });
});

loadLottieAnimations = () => {
    let lottieElements = document.querySelectorAll(".lottie");
    let lottieAnimations = [];
    let window_top = window.scrollY;

    lottieElements.forEach((lottieEl) => {
        let lottieAnimation = bodymovin.loadAnimation({
            container: lottieEl,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: lottieEl.dataset.url
        });
        let div_top = lottieEl.getBoundingClientRect().top + window.scrollY;
        if (window_top + window.innerHeight > div_top + 200) {
            lottieAnimation.play();
            lottieEl.classList.add("played");
        }
        lottieAnimations.push({lottieEl, lottieAnimation});
    
    });
    return lottieAnimations;
}


if (document.querySelectorAll(".lottie").length) {
    let lottieAnimations = loadLottieAnimations();

    document.addEventListener("scroll", () => {            
        lottieAnimations.forEach((lottie) => {
            let window_top = window.scrollY;
            let div_top = lottie.lottieEl.getBoundingClientRect().top + window.scrollY;

            if (window_top + window.innerHeight > div_top + 200 && !lottie.lottieEl.classList.contains("played")) {
                lottie.lottieAnimation.play();
                lottie.lottieEl.classList.add("played");
                console.log("played");
            }
        });
    });

}
